import { render, staticRenderFns } from "./PermissionsEditor.vue?vue&type=template&id=04d863b4&scoped=true"
import script from "./PermissionsEditor.vue?vue&type=script&lang=js"
export * from "./PermissionsEditor.vue?vue&type=script&lang=js"
import style0 from "./PermissionsEditor.vue?vue&type=style&index=0&id=04d863b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d863b4",
  null
  
)

export default component.exports